<div style="padding: 10px;">
    <section class="convesation-header">
      <span class="doctor">Doctor Who. MD</span>
      <span class="date">2/20/19</span>
    </section>
    <hr>
    <section class="message-body">
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Commodi magnam explicabo tenetur reiciendis praesentium molestias voluptatum labore voluptatem blanditiis cum repudiandae laudantium, aspernatur hic ea fuga esse temporibus adipisci odio?</p>
    </section>
    <hr>
    <section class="files">
        <div class="file"></div>
        <div class="file"></div>
    </section>
</div>
